<div class="view-outward-container outward-l2approver" *ngIf="!showLoading" [ngClass]="{'mobile-view': isMobileView}">
  <div class="mt-1">
    <div class="row header-row" style="border-bottom: 1px solid #d0d0ce;margin-left: 4px;margin-right:4px; align-items: center;">
      <div class="d-flex col-7 header-title">
         <h1 class="header-title-text mb-0" style="word-wrap: break-word; white-space: normal;">{{requestName}}</h1>
      </div>

        <div *ngIf="(EditOutwardDetails.status === 'Created' || EditOutwardDetails.status === 'Declined') && isL1Approver()" class="col-5 d-flex justify-content-end header-actions">
          <button *ngIf="EditOutwardDetails.status === 'Created'" class="button red" (click)="onRejectL1(EditOutwardDetails)" type="button" style="color:rgb(232, 53, 53)">
            Decline &#10006;
          </button>
          <button *ngIf="EditOutwardDetails.status === 'Created'" class="button" (click)="onAcceptL1(EditOutwardDetails)" type="button" style="background-color: #26b818;">
            Accept &#10004;
          </button>
        </div>
        
              <!-- <div  *ngIf="EditOutwardDetails.status==='LA approved 1'" class="col-md-9 d-flex justify-content-end"> -->
        <div *ngIf="(EditOutwardDetails.status === 'LA approved 1' || EditOutwardDetails.status === 'Declined') && isL2Approver()" class="col-5 d-flex justify-content-end header-actions">
          <button *ngIf="EditOutwardDetails.status === 'LA approved 1'" class="button red" (click)="onReject(EditOutwardDetails)" type="button" style="color:rgb(232, 53, 53)">
            Decline &#10006;
          </button>
          <button *ngIf="EditOutwardDetails.status === 'LA approved 1'" class="button" (click)="onAccept(EditOutwardDetails)" type="button" style="background-color: #26b818;">
            Accept &#10004;
          </button>
        </div>
    </div>

  </div>



  <!-- <div class="mt-1">
    <div class="row" style="border-bottom: 1px solid #d0d0ce;margin-left: 10px;margin-right:10px">
      <div class="col-md-3">
        <h1>{{requestName}}</h1>
      </div>
  </div>

  </div> -->

<div id="accordion" class="accordion">
  <div class="card"  style="border-bottom: 1px solid lightgrey;">
    <div id="headingOne" class="card-header bg-white border-0">
      <h5 class="mb-0 font-weight-bold">
        <a href="#" style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="d-block position-relative text-dark collapsible-link py-2">General Information</a>
      </h5>
      <app-outward-progress-bar></app-outward-progress-bar>
      <br/>
      <div *ngIf="status=='Cancelled'">
        <strong>Cancel Reason</strong>
        <span>{{cancelledByNotes}}</span>
      </div>
      <div *ngIf="status=='Declined'">
        <strong>Decline Reason</strong>
        <span>{{declinedByNotes}}</span>
      </div>
    </div>
    <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion" class="collapse show">

      <div id="dBox" class="card-body" [ngClass]="{'mobile-grid': isMobileView}" style="padding:10px">


        <div class="item1">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>Request name <span class="required">*</span></strong>
              <span>{{requestName}}</span>
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="form-group mt-1">
            <strong>Request type <span class="required">*</span></strong>
            <span>{{requestTypeName}}</span>
          </div>
        </div>
        <div class="item3">
          <div class="form-group mt-1">
            <strong>Request date <span class="required">*</span></strong>
            <span>{{requestDateTime}}</span>
          </div>
        </div>
        <div class="item4">
          <div class="form-group mt-1">
            <strong>Request time <span class="required">*</span></strong>
            <span>{{fromtimevalue}}</span>
          </div>

        </div>
        <div class="item5" *ngIf="requestTypeName=='Returnable'||requestTypeName=='Internal movement'">
          <div class="form-group mt-1">
            <strong>Due date <span class="required">*</span></strong>
            <span>{{returnDateTime}}</span>
          </div>
        </div>
        <div class="item6" *ngIf="requestTypeName=='Returnable'||requestTypeName=='Internal movement'">
          <div class="form-group mt-1">
            <strong>Due time <span class="required">*</span></strong>
            <span>{{duetimevalue}}</span>
          </div>

        </div>
        <div class="item23" *ngIf="requestTypeName=='Returnable'">
          <div class="form-group mt-1">
            <strong>Revised Due date <span class="required">*</span></strong>
            <span>{{revisedDateTime}}</span>
          </div>
        </div>
        <div class="item24" *ngIf="requestTypeName=='Returnable'">
          <div class="form-group mt-1">
            <strong>Revised Due time <span class="required">*</span></strong>
            <span>{{revisedduetimevalue}}</span>
          </div>

        </div>
        <div class="item7">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>Material sent to <span class="required">*</span></strong>
              <span>{{materialSentToVendorName}}</span>
            </div>
          </div>
        </div>
        <div class="item8">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>Practice <span class="required">*</span></strong>
              <span>{{practiceName}}</span>
            </div>
          </div>
        </div>
        <div class="item9">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>LA approver 1 <span class="required">*</span></strong>
              <span>{{approverEmailL1}}</span>
            </div>
          </div>
        </div>
        <div class="item10">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>LA approver 2 <span class="required">*</span></strong>
              <span>{{approverEmailL2}}</span>
            </div>
          </div>
        </div>

        <!-- <div class="item11" >
            <div class="from-group mt-1" >
                <div class="form-group typeahead-wrap mt-1" style="width:100%">
                  <strong>Authorized by <span class="required">*</span></strong>
                 <span>{{authorizedBy}}</span>
                </div>
            </div>
        </div>   -->
        <div class="item11">
          <div class="from-group mt-1">
            <div class="form-group typeahead-wrap mt-1" style="width:100%">
              <strong>Material carried by <span class="required">*</span></strong>
              <span>{{materialCarriedByVendorName}}</span>
            </div>
          </div>
        </div>
        <div class="item12">
          <div class="from-group mt-1">
            <strong>Request ID</strong>
            <span>{{serialNumber}}</span>
          </div>
        </div>
        <div class="item13">
          <div class="from-group mt-1">
            <strong>G.P. No</strong>
            <span>{{gatepassNumber}}</span>
          </div>

        </div>
        <div class="item14">
          <div class="from-group mt-1">
            <strong>City</strong>
            <span>{{cityName}}</span>
          </div>
        </div>
        <div class="item15">
          <div class="from-group mt-1">
            <strong>Office</strong>
            <span>{{officeName}}</span>
          </div>
        </div>
        <div class="item17">
          <div class="from-group mt-1">
            <strong>Purpose <span class="required">*</span></strong>
            <span>{{purpose}}</span>
          </div>
        </div>
        <!-- <div class="item18">
            <div class="from-group mt-1">
                <strong>Office</strong>
               <span>{{officeName}}</span>
            </div>
        </div>
        <div class="item19">
            <div class="from-group mt-1">
                <strong>City</strong>
                <span>{{cityName}}</span>
            </div>
        </div>   -->
        <div class="item20">
          <div class="form-group mt-1">
            <strong>Notes :</strong>
            <span>{{remark == '' ? '-' : remark}}</span>
          </div>
        </div>

      </div>
    </div>
    <!-- <div *ngIf="status=='Cancelled'">
      <strong>Cancel Reason</strong>
      <span>{{declinedByNotes}}</span>
    </div>  -->

  </div>


  <!-- Materials DropDown -->
  <!-- <div id="headingOne" class="card-header bg-white border-0">
    <h4 class="mb-0 font-weight-bold"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" class="d-block position-relative text-dark py-2">Materials</span></h4>
  </div> -->
  <div class="mt-1 materials-wrapper">
    <div class="col-md-3,attchmentTable" style="margin-top: 10px;">
      <div *ngIf="attachedFiles.length > 0">
        <h3>Attached Files:</h3>
      </div>
      <!-- <ul>
        <li *ngFor="let file of attachedFiles; let i = index">
          {{ file.name }}
          <img src="assets/images/view1.png" alt="View" width="20" height="20" (click)="viewFile(i)" style="cursor: pointer;margin-left: 20px;">
        </li>
      </ul> -->
      <ul [ngStyle]="{'list-style': isMobileView ? 'none' : 'initial', 'padding-left': isMobileView ? '0' : 'initial'}">
      <li *ngFor="let file of attachedFiles; let i = index" [ngStyle]="{'display': isMobileView ? 'flex' : 'block', 'align-items': isMobileView ? 'flex-start' : 'initial', 'margin-bottom': isMobileView ? '8px' : 'initial'}">
      <span [ngStyle]="{'flex': isMobileView ? '1' : 'initial', 'word-wrap': isMobileView ? 'break-word' : 'initial', 'word-break': isMobileView ? 'break-word' : 'initial', 'margin-right': isMobileView ? '10px' : '0'}">{{ file.name }}</span>
      <img src="assets/images/view1.png" alt="View" width="20" height="20" (click)="viewFile(i)" [ngStyle]="{'cursor': 'pointer', 'margin-left': isMobileView ? '0' : '20px', 'flex-shrink': isMobileView ? '0' : 'initial'}">
      </li>
      </ul>
    </div>
    <div class="materials-header">
      <h3 class="materials-title">Materials</h3>
    </div>
    <div class="materials-search-row">
      <div class="form-group has-search materials-search">
        <span class="icon-ic_search form-control-search"></span>
        <input class="form-control frontIcon searchtext" [(ngModel)]="searchText" #searchMat id="searchMat" autocomplete="off" placeholder="Search by description">
      </div>
    </div>

  </div>
  <div class="card materials-card" *ngIf="materialList.length > 0 && !isMobileView">
    <div [ngClass]="{'scrollable':(materialList.length > 5 && searchText.length==0)}">
      <table class="demTable materials-table">
        <thead>
          <tr>
            <th>S.No.</th>
            <th width="20%">Description</th>
            <th>
              <span *ngIf="!isMobileView">Required Quantity</span>
              <span *ngIf="isMobileView">Required<br>Quantity</span>
            </th>
            <th width="50%">Serial Number/Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row" *ngFor="let material of materialList | filter : searchText;let i=index">
            <td>&nbsp;<span style="margin-left:5px;">{{i+1}}</span></td>
            <td>
              <div class="BoxOne" style="text-align: left">
                <span style="margin-right: 20px">{{material.name}}</span>
              </div>
            </td>
            <td>
              <div class="BoxOne">
                <span style="margin-right:127px;">{{material.quantity}}</span>
              </div>
            </td>
            <td>
              <div class="BoxOne">
                <span style="margin-right:530px;">{{material.notes == '' ? '-' : material.notes}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    <div class="card materials-card" *ngIf="materialList.length > 0 && isMobileView">
      <div>
        <table class="demTable mobile-demTable materials-table">
          <thead>
            <tr>
             <th style="width: 35px; font-size: 12px; padding: 8px 4px;">S.No.</th>
<th width="28%" style="font-size: 12px; padding: 8px 4px; word-wrap: break-word;">Description</th>
<th width="22%" style="font-size: 11px; padding: 8px 4px; word-wrap: break-word; white-space: normal;">Required Quantity</th>
<th width="35%" style="font-size: 12px; padding: 8px 4px; word-wrap: break-word;">Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" *ngFor="let material of materialList | filter : searchText;let i=index">
              <td><span>{{i+1}}</span></td>
              <td>
                <span>{{material.name}}</span>
              </td>
              <td>
                <span>{{material.quantity}}</span>
              </td>
              <td>
                <span>{{material.notes == '' ? '-' : material.notes}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>
</div>
